import { Modal } from 'antd';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * This component represents a remove project members modal.
 * @param props - the props
 */
export const DeleteProjectMemberModal: React.FC<Props> = (props) => {
    const [deleting, setDeleting] = useState(false);

    const cancel = async () => {
        props.onCancel();
    };

    const remove = async () => {
        try {
            setDeleting(true);
            await props.onDelete();
        } finally {
            setDeleting(false);
        }
    };

    return (
        <Modal
            title={<FormattedMessage id="projectMembers.delete.modal.title" />}
            visible={props.visible}
            onCancel={cancel}
            onOk={remove}
            okButtonProps={{ loading: deleting }}
            cancelButtonProps={{ disabled: deleting }}
        >
            <FormattedMessage id="projectMembers.delete.modal.description.1" />{' '}
            <strong>
                <FormattedMessage id="projectMembers.delete.modal.description.2" />
            </strong>
        </Modal>
    );
};
export default DeleteProjectMemberModal;

interface Props {
    visible?: boolean;
    onDelete: () => Promise<void>;
    onCancel: () => void;
}
